import { useMemo } from 'react';
import _ from 'underscore';
import { prop } from 'ramda';
import { useLocation } from 'react-router-dom';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

export const useGetSubscriptionActionTypes = () => {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const clientPlatform = useDeviceSelector(prop('clientPlatform'));
    const sessionSubscriptionTypes = useAppSelector(prop('sessionSubscriptionTypes'));
    const disableMessageSubscriptions = searchParams.get('disableMessageSubscriptions');

    return useMemo(() => {
        if (disableMessageSubscriptions === 'all') {
            return [];
        }

        if (clientPlatform === 'download') {
            return ['bonus'];
        }

        // eslint-disable-next-line no-undef
        if (Playtech.Variables.isGameWrapper) {
            return ['rg:realitycheck', 'ip-changed', 'acl-rules-failed'];
        }

        if (disableMessageSubscriptions) {
            const decodedDisableMessageSubscriptions = decodeURIComponent(disableMessageSubscriptions);

            return _.difference(sessionSubscriptionTypes || [], decodedDisableMessageSubscriptions.split(','));
        }

        return sessionSubscriptionTypes || [];
    }, [clientPlatform, disableMessageSubscriptions, sessionSubscriptionTypes]);
};
